<cb-dialog-layout width="400px" [title]="title | translate" icon="cb-base-outline-bug">
    <ng-template #Body>
        <cb-form [formGroup]="formGroup" (onSubmit)="saveAndClose($event)">

            <cb-form-group [columns]="1">
                <cb-form-item name="notes" [data]="{type: 'textarea'}"
                    [editorOptions]="{autosize: true, maxRows: 14, rows:3}"
                    [label]="'BUG_REPORT.NOTES.LABEL' | translate"
                    [placeholder]="'BUG_REPORT.NOTES.PLACEHOLDER' | translate"></cb-form-item>

                <cb-form-item name="attachments" [data]="{type: 'file'}"
                    [editorOptions]="{multiple: true, bucketName:'bug_reports', generateRandomName: true, uploadBehavior: 'onSubmit'}"
                    [label]="'BUG_REPORT.ATTACHMENTS.LABEL' | translate"
                    [placeholder]="'BUG_REPORT.ATTACHMENTS.PLACEHOLDER' | translate"></cb-form-item>
            </cb-form-group>

            <cb-global-form-controls>
                <cb-button type="submit" [label]="'COMMON.SAVE' | translate" icon="cb-base-outline-save"></cb-button>
            </cb-global-form-controls>
        </cb-form>
    </ng-template>

    <ng-template #RightButtons>
        <cb-global-form-controls-host></cb-global-form-controls-host>
    </ng-template>
</cb-dialog-layout>